import React, { useEffect, useState } from "react";
import "./editAlerts.css";
import alertaumbral from "../../assets/alertaumbral.png";
import alertatunel from "../../assets/alertatunel.png";
import alertaausencia from "../../assets/alertafaltadatos.png";
import alertamaximetro from "../../assets/alertamaximetro.png";
import alertareactiva from "../../assets/alertareactiva.png";
import alertacoste from "../../assets/alertacoste.png";
import { useDispatch, useSelector } from "react-redux";
import { getAllUsers } from "../../redux/apiCalls/usersCall.js/usersCall";
import {
  updateAlert,
  getAlertById,
} from "../../redux/apiCalls/alertsCall/alertsCall";
import { useParams, useNavigate } from "react-router-dom";
import CostAlertFormEdit from "../../components/alerts/alertsEdit/CostAlertFormEdit";
import DataAbsenceAlertFormEdit from "../../components/alerts/alertsEdit/DataAbsenceAlertFormEdit";
import MaximumDemandAlertFormEdit from "../../components/alerts/alertsEdit/MaximumDemandAlertFormEdit";
import ReactiveAlertFormEdit from "../../components/alerts/alertsEdit/ReactiveAlertFormEdit";
import ThresholdAlertFormEdit from "../../components/alerts/alertsEdit/ThresholdAlertFormEdit";
import TunnelAlertFormEdit from "../../components/alerts/alertsEdit/TunnelAlertFormEdit";
import InvoicePenaltyAlertFormEdit from "../../components/alerts/alertsEdit/InvoicePenaltyAlertFormEdit";

const EditAlerts = () => {
  const dispatch = useDispatch();
  const userToken = useSelector((state) => state.user.currentUser?.accessToken);
  const devices = useSelector((state) => state.devices.currentDevices);
  const users = useSelector((state) => state.users.users);
  const userPrivilege = useSelector(
    (state) => state.user.currentUser?.privilege
  );
  const { id } = useParams();
  const [step, setStep] = useState(id ? 2 : 1);
  const [selectedType, setSelectedType] = useState(null);
  const [initialData, setInitialData] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!users || users.length === 0) {
      getAllUsers(dispatch, userToken);
    }
  }, [users, dispatch, userToken]);

  useEffect(() => {
    if (id && userToken) {
      getAlertById(dispatch, id, userToken).then((alert) => {
        if (alert) {
          setInitialData(alert);
          setSelectedType(alert.type?.toLowerCase());
          setStep(2);
        }
      });
    }
  }, [id, userToken, dispatch]);

  const deviceOptions = Array.isArray(devices)
    ? devices.map((device) => ({
        value: device.id,
        label: `${device.name} (${device.serial_number})`,
        data: device,
      }))
    : [];

  const userOptions = Array.isArray(users)
    ? users.map((u) => ({
        id: u.id_user,
        email: u.mail,
        phone: u.phone,
        id_company: u.id_company,
        id_branch: u.id_branch,
        id_local: u.id_local,
        id_place: u.id_place,
        id_zone: u.id_zone,
        privilege: u.privilege,
      }))
    : [];

  const alertTypes = [
    { id: "umbral", label: "Alerta umbral", img: alertaumbral },
    { id: "ausencia", label: "Ausencia datos", img: alertaausencia },
    { id: "maximetro", label: "Exceso maximetro", img: alertamaximetro },
    { id: "reactiva", label: "Exceso reactiva", img: alertareactiva },
    { id: "coste", label: "Coste", img: alertacoste },
    { id: "tunel", label: "Alerta tunel", img: alertatunel },
    { id: "penalizacion", label: "Penalización factura", img: alertacoste },
  ];

  const renderForm = () => {
    const commonProps = {
      devices: deviceOptions,
      users: userOptions,
      privilege: userPrivilege,
      initialData,
      onCancel: () => navigate("/list-alerts"),
      onSave: async (data) => {
        if (!userToken) return;

        try {
          setIsSaving(true);
          if (id) {
            await updateAlert(dispatch, id, data, userToken);
          }
          navigate("/list-alerts");
        } catch (e) {
          console.error("Error guardando alerta:", e);
        } finally {
          setIsSaving(false);
        }
      },
      isSaving, // por si querés deshabilitar botones en los formularios
    };

    switch (selectedType) {
      case "umbral":
        return <ThresholdAlertFormEdit {...commonProps} />;
      case "ausencia":
        return <DataAbsenceAlertFormEdit {...commonProps} />;
      case "maximetro":
        return <MaximumDemandAlertFormEdit {...commonProps} />;
      case "reactiva":
        return <ReactiveAlertFormEdit {...commonProps} />;
      case "coste":
        return <CostAlertFormEdit {...commonProps} />;
      case "tunel":
        return <TunnelAlertFormEdit {...commonProps} />;
      case "penalizacion":
        return <InvoicePenaltyAlertFormEdit {...commonProps} />;
      default:
        return null;
    }
  };

  return (
    <div className="editAlert-container">
      <div className="Editsteps">
        <div
          className={`step ${step === 1 ? "active" : ""}`}
          style={{ cursor: step === 2 ? "pointer" : "default" }}
          onClick={() => {
            if (id) {
              navigate("/list-alerts");
            } else if (step === 2) {
              setStep(1);
            }
          }}
        >
          1
        </div>
        <div className={`step ${step === 2 ? "active" : ""}`}>2</div>
      </div>

      {/* Paso 1: Selección tipo (solo si no se está editando) */}
      {!id && step === 1 && (
        <div className="EditAlert-types">
          {alertTypes.map((t) => (
            <div
              key={t.id}
              className="editAlert-card"
              onClick={() => {
                setSelectedType(t.id);
                setStep(2);
              }}
            >
              <img src={t.img} alt={t.label} className="editAlert-img" />
              <div className="label">{t.label}</div>
            </div>
          ))}
        </div>
      )}

      {/* Paso 2: Formulario */}
      {step === 2 && renderForm()}
    </div>
  );
};

export default EditAlerts;
